/* Linsoul product bottom bar: section links for sections on the page, purchase shortcut mirroring the hero's state. */
(() => {
  'use strict';

  function initDock(dock) {
    const links = [...dock.querySelectorAll('[data-lsd-link]')];
    const row = dock.querySelector('[data-lsd-links]');
    const cta = dock.querySelector('[data-lsd-cta]');
    const ctaLabel = dock.querySelector('[data-lsd-cta-label]');
    const price = dock.querySelector('[data-lsd-price]');
    const thumb = dock.querySelector('[data-lsd-thumb]');
    const variantOut = dock.querySelector('[data-lsd-variant]');
    const qtyOut = dock.querySelector('[data-lsd-qty]');
    const errorOut = dock.querySelector('[data-lsd-error]');
    const heroBuy = document.querySelector('[data-lsp-buy]');
    const heroForm = document.querySelector('[data-lsp-form]');
    let pastHero = dock.dataset.show === 'always' || !heroBuy;
    let overlayOpen = false;
    let keyboardOpen = false;

    const targetsFor = (link) => link.dataset.lsdTargets.split(',').map((id) => document.getElementById(id)).filter((el) => el && !el.hidden && el.offsetParent !== null);

    const refreshLinks = () => {
      links.forEach((link) => {
        const found = targetsFor(link);
        link.closest('li').hidden = found.length === 0;
        if (found.length) link.setAttribute('href', `#${found[0].id}`);
      });
    };

    const setActive = () => {
      const line = window.innerHeight * 0.35;
      let active = null;
      links.forEach((link) => {
        if (link.closest('li').hidden) return;
        targetsFor(link).forEach((target) => {
          const box = target.getBoundingClientRect();
          if (box.top <= line && box.bottom > line) active = link;
        });
      });
      links.forEach((link) => {
        if (link === active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (active && row && row.scrollWidth > row.clientWidth) {
        const left = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
        row.scrollTo({ left, behavior: 'smooth' });
      }
    };

    const isLocked = () => {
      const html = document.documentElement;
      return overlayOpen
        || html.style.overflow === 'hidden'
        || html.classList.contains('prevent-scroll')
        || html.classList.contains('ls-scroll-lock')
        || Boolean(document.querySelector('dialog[open]'));
    };

    const render = () => {
      const visible = pastHero && !isLocked() && !keyboardOpen;
      dock.toggleAttribute('data-visible', visible);
      dock.inert = !visible;
      document.body.style.setProperty('--ls-dock-h', visible ? `${dock.offsetHeight}px` : '0px');
    };

    if (heroBuy && dock.dataset.show !== 'always') {
      new IntersectionObserver(([entry]) => {
        pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        render();
      }).observe(heroBuy);
    }

    new MutationObserver(render).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    document.addEventListener('linsoul:overlay', (event) => {
      overlayOpen = Boolean(event.detail?.open);
      render();
    });
    document.addEventListener('close', () => setTimeout(render), true);

    if (window.visualViewport) {
      const onViewport = () => {
        const field = document.activeElement;
        const typing = field && field.matches('input:not([type=radio]):not([type=checkbox]), textarea, select, [contenteditable]');
        keyboardOpen = Boolean(typing) && window.visualViewport.height < window.innerHeight * 0.75;
        render();
      };
      window.visualViewport.addEventListener('resize', onViewport);
      document.addEventListener('focusout', () => setTimeout(onViewport, 50));
    }

    document.addEventListener('linsoul:product-state', (event) => {
      const state = event.detail || {};
      if (price && state.variant) price.innerHTML = state.variant.price;
      const thumbSrc = state.variant?.featured_image?.src;
      if (thumb && thumbSrc) {
        const url = new URL(thumbSrc, location.href);
        url.searchParams.set('width', '120');
        if (thumb.dataset.src !== url.href) {
          thumb.dataset.src = url.href;
          thumb.removeAttribute('srcset');
          thumb.src = url.href;
        }
      }
      if (variantOut && state.variant && Array.isArray(state.variant.options)) {
        const title = state.variant.options.join(' / ');
        variantOut.textContent = title === 'Default Title' ? '' : title;
      }
      if (qtyOut) {
        qtyOut.hidden = !(state.quantity > 1);
        qtyOut.textContent = (dock.dataset.labelQty || '').replace('[qty]', state.quantity);
      }
      if (cta) {
        cta.disabled = Boolean(state.disabled);
        cta.setAttribute('aria-busy', String(Boolean(state.busy)));
        if (ctaLabel && state.label) ctaLabel.textContent = state.label;
      }
      if (errorOut) {
        errorOut.textContent = state.error || '';
        errorOut.hidden = !state.error;
      }
      requestAnimationFrame(render);
    });

    dock.querySelector('[data-lsd-top]')?.addEventListener('click', () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });

    cta?.addEventListener('click', () => {
      if (!heroForm) return;
      if (typeof heroForm.requestSubmit === 'function') heroForm.requestSubmit();
      else heroForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    let raf = 0;
    window.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActive);
    }, { passive: true });
    new ResizeObserver(render).observe(dock);
    document.addEventListener('linsoul:sections-changed', () => { refreshLinks(); setActive(); });
    window.addEventListener('load', refreshLinks);

    refreshLinks();
    setActive();
    render();
    document.querySelector('[data-lsp-hero]')?.lspRequestState?.();
  }

  const init = () => document.querySelectorAll('[data-lsd]').forEach((dock) => {
    if (dock.dataset.lsdReady) return;
    dock.dataset.lsdReady = '1';
    initDock(dock);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
